import React from 'react';
import PropTypes from 'prop-types';
import {
    renderPercentageLines,
    renderDateRange,
    renderChartPoints
} from './accuracy-overview-graph.utils';
import css from './accuracy-overview-graph.scss';

export const AccuracyOverviewGraph = ({ dateRange, averageAccuracies }) => (
    <div>
        <div>
            {renderPercentageLines()}
            <div className={css.chartPoints}>
                {renderChartPoints(dateRange, averageAccuracies)}
            </div>
        </div>
        <div id="months" className={css.months}>
            {renderDateRange(dateRange)}
        </div>
    </div>
);

AccuracyOverviewGraph.propTypes = {
    dateRange: PropTypes.string,
    averageAccuracies: PropTypes.arrayOf(
        PropTypes.shape({
            accuracy: PropTypes.number,
            weekStartDate: PropTypes.string
        })
    )
};



// WEBPACK FOOTER //
// ./components/accuracy-overview-graph/accuracy-overview-graph.js